import { Store } from '../../types';
import { CmsComponent, JsxArgs } from '../cms/CmsComponent';
import { PopularCategoryItem } from '../cms/CmsPopularCategories/CmsPopularCategories';

export const PopularCategories = ({ store, onClick }: { store: Store; onClick: (searchWord: string) => void }) => {
	let jsx: JsxArgs;
	// STORE FIX: update this switch block to include new stores (ideally this component should move to the CMS)
	switch (store) {
		case 'kgse':
			jsx = [
				'CmsPopularCategories',
				{
					onClick: (item: PopularCategoryItem) => {
						onClick(item.title);
					},
					categories: [
						{
							img: '/images/toiletPaper.svg',
							link: '/fika-stad-torkpapper-c-5210000_5215000.html',
							title: 'Torkpapper',
						},
						{
							title: 'Gaffelpärmar',
							img: '/images/notebook.svg',
							link: '/parmar-tillbehor-gaffelparmar-c-4250000_4251400_8111055.html',
						},
						{
							title: 'Anteckningsblock',
							img: '/images/notepad.svg',
							link: '/block-blanketter-block-blockkuber-c-2970000_2971800.html',
						},
						{
							title: 'Kopieringspapper',
							img: '/images/noteBlank.svg',
							link: '/papper-kopieringspapper-c-2650000_2651400.html',
						},
						{
							title: 'Pyssel',
							img: '/images/scissors.svg',
							link: '/skola-forskola-hobbymateriel-c-5900000_8110635.html',
						},
						{
							title: 'Kaffe',
							img: '/images/coffee.svg',
							link: '/c/kontorsmaterial/kaffe-fika-servering/kaffe-dryck',
						},
						{
							title: 'Engångsservis',
							img: '/images/forkKnife.svg',
							link: '/fika-stad-engangsservis-c-5210000_5212600.html',
						},
						{
							title: 'Handdesinfektion',
							img: '/images/handSoap.svg',
							link: '/desinfektion-handdesinfektion-c-5210000_5217100_5217110.html',
						},
						{
							title: 'Whiteboard',
							img: '/images/chalkboardSimple.svg',
							link: '/c/mobler-inredning/whiteboardtavlor-whiteboard/whiteboardtavlor-whiteboard',
						},
						{
							title: 'Städredskap',
							img: '/images/spinner.svg',
							link: '/fika-stad-redskap-c-5210000_5218200.html',
						},
					],
				},
			];
			break;
		case 'kgno':
			jsx = [
				'CmsPopularCategories',
				{
					onClick: (item: PopularCategoryItem) => {
						onClick(item.title);
					},
					categories: [
						{
							title: 'Aftørring ',
							img: '/images/toiletPaper.svg',
							link: '/c/rengoring-aftorring/aftorring-toiletpapir',
						},
						{
							title: 'Brevordner',
							img: '/images/notebook.svg',
							link: '/c/kontor-papir/sortering-opbevaring/brevordner',
						},
						{
							title: 'Notesbøger',
							img: '/images/notepad.svg',
							link: '/c/kontor-papir/blok-notes/blokke-notesboger',
						},
						{
							title: 'Kopipapir',
							img: '/images/noteBlank.svg',
							link: '/c/kontor-papir/papir-etiketter/printerpapir-kopipapir',
						},
						{ title: 'Hobbyartikler', img: '/images/scissors.svg', link: '/c/skole-hobby/hobbyartikler' },
						{ title: 'Kaffe & Te', img: '/images/coffee.svg', link: '/c/kokken-drikke/kaffe-drikkevarer' },
						{ title: 'Ergonomi', img: '/images/ergonomi.svg', link: '/c/kontorindretning/ergonomi' },
						{
							title: 'Rengøringsredskab',
							img: '/images/handSoap.svg',
							link: '/c/rengoring-aftorring/rengoringsredskaber',
						},
						{
							title: 'Kontorstole',
							img: '/images/office-chair.svg',
							link: '/c/kontorindretning/mobler/kontorstole',
						},
						{
							title: 'Whiteboard',
							img: '/images/chalkboardSimple.svg',
							link: '/c/kontor-papir/whiteboard-opslagstavler',
						},
					],
				},
			];
			break;
		case 'kgdk':
			jsx = [
				'CmsPopularCategories',
				{
					onClick: (item: PopularCategoryItem) => {
						onClick(item.title);
					},
					categories: [
						{
							title: 'Aftørring',
							img: '/images/toiletPaper.svg',
							link: '/c/rengoring-aftorring/aftorring-toiletpapir',
						},
						{
							title: 'Brevordner',
							img: '/images/notebook.svg',
							link: '/c/kontor-papir/sortering-opbevaring/brevordner',
						},
						{
							title: 'Notesbøger',
							img: '/images/notepad.svg',
							link: '/c/kontor-papir/blok-notes/blokke-notesboger',
						},
						{
							title: 'Kopipapir',
							img: '/images/noteBlank.svg',
							link: '/c/kontor-papir/papir-etiketter/printerpapir-kopipapir',
						},
						{ title: 'Hobbyartikler', img: '/images/scissors.svg', link: '/c/skole-hobby/hobbyartikler' },
						{ title: 'Kaffe & Te', img: '/images/coffee.svg', link: '/c/kokken-drikke/kaffe-drikkevarer' },
						{ title: 'Ergonomi', img: '/images/ergonomi.svg', link: '/c/kontorindretning/ergonomi' },
						{
							title: 'Rengøringsredskab',
							img: '/images/handSoap.svg',
							link: '/c/rengoring-aftorring/rengoringsredskaber',
						},
						{
							title: 'Kontorstole',
							img: '/images/office-chair.svg',
							link: '/c/kontorindretning/mobler/kontorstole',
						},
						{
							title: 'Whiteboard',
							img: '/images/chalkboardSimple.svg',
							link: '/c/kontor-papir/whiteboard-opslagstavler',
						},
					],
				},
			];
			break;
		case 'kgnl':
			jsx = [
				'CmsPopularCategories',
				{
					onClick: (item: PopularCategoryItem) => {
						onClick(item.title);
					},
					categories: [
						{
							title: 'Handdoekpapier',
							img: '/images/toiletPaper.svg',
							link: '/c/handdoekpapier',
						},
						{
							title: 'Ordners',
							img: '/images/notebook.svg',
							link: '/c/ordners-ringbanden',
						},
						{
							// TODO: update this for kgnl: was "Anteckningsblock" in kgse
							title: 'Archiveren',
							img: '/images/notepad.svg',
							link: '/c/kantoor-papier/archiveren-sorteren',
						},
						{
							title: 'Kopieerpapier',
							img: '/images/noteBlank.svg',
							link: '/c/etiketten-enveloppen',
						},
						{
							title: 'Creatief Materiaal',
							img: '/images/scissors.svg',
							link: '/c/school-hobby/creatief-materiaal',
						},
						{
							title: 'Koffie',
							img: '/images/coffee.svg',
							link: '/c/keuken-dranken/koffie-thee',
						},
						{
							title: 'Servies',
							img: '/images/forkKnife.svg',
							link: '/c/keuken-dranken/servies-bekers',
						},
						{
							title: 'Handdesinfectie',
							img: '/images/handSoap.svg',
							link: '/c/schoonmaak-hygiene/zeep-lichaamsverzorging/handdesinfectie',
						},
						{
							// TODO: update this for kgnl
							title: 'Whiteboard',
							img: '/images/chalkboardSimple.svg',
							link: '/c/mobler-inredning/whiteboardtavlor-whiteboard/whiteboardtavlor-whiteboard',
						},
						{
							title: 'Schoonmaakmateriaal',
							img: '/images/spinner.svg',
							link: '/c/schoonmaak-hygiene/schoonmaakmateriaal',
						},
					],
				},
			];
			break;
		default:
			jsx = [
				'CmsPopularCategories',
				{
					onClick: (item: PopularCategoryItem) => {
						onClick(item.title);
					},
					categories: [
						{
							title: 'Aftørring ',
							img: '/images/toiletPaper.svg',
							link: '/c/rengoring-aftorring/aftorring-toiletpapir',
						},
						{
							title: 'Brevordner',
							img: '/images/notebook.svg',
							link: '/c/kontor-papir/sortering-opbevaring/brevordner',
						},
						{
							title: 'Notesbøger',
							img: '/images/notepad.svg',
							link: '/c/kontor-papir/blok-notes/blokke-notesboger',
						},
						{
							title: 'Kopipapir',
							img: '/images/noteBlank.svg',
							link: '/c/kontor-papir/papir-etiketter/printerpapir-kopipapir',
						},
						{ title: 'Hobbyartikler', img: '/images/scissors.svg', link: '/c/skole-hobby/hobbyartikler' },
						{ title: 'Kaffe & Te', img: '/images/coffee.svg', link: '/c/kokken-drikke/kaffe-drikkevarer' },
						{ title: 'Ergonomi', img: '/images/ergonomi.svg', link: '/c/kontorindretning/ergonomi' },
						{
							title: 'Rengøringsredskab',
							img: '/images/handSoap.svg',
							link: '/c/rengoring-aftorring/rengoringsredskaber',
						},
						{
							title: 'Kontorstole',
							img: '/images/office-chair.svg',
							link: '/c/kontorindretning/mobler/kontorstole',
						},
						{
							title: 'Whiteboard',
							img: '/images/chalkboardSimple.svg',
							link: '/c/kontor-papir/whiteboard-opslagstavler',
						},
					],
				},
			];
	}
	return <CmsComponent structure={jsx} />;
};
